import view from 'bundle-text:../dom/404.html'; // eslint-disable-line
import app from './app';

export default () => {
  const content = document.createElement('div');

  content.classList.add(
    'align-items-center',
    'd-flex',
    'justify-content-center',
    'w-100',
  );
  content.innerHTML = view;

  document.title = `${app.run.settings.view[404].pageTitle}${app.run.settings.siteTitleSeparator}${app.run.settings.siteTitle}`;

  return content;
};
